import {useEffect, useState} from 'react'

const PREFIX = process.env.REACT_APP_PREFIX;

/**
 * @desc step 1713: use localstorage as state
 * @returns {JSX.Element}
 * @constructor
 */
export default function useLocalStorage(key, initialValue) {
    const prefixedKey = PREFIX + key
    const [value, setValue] = useState(() => {
        const jsonValue = localStorage.getItem(prefixedKey)
        if (jsonValue !== null && jsonValue !== undefined && jsonValue !== '') return JSON.parse(jsonValue)
        if (typeof initialValue === 'function') {
            return initialValue()
        } else {
            return initialValue
        }
    })


    useEffect(() => {
        localStorage.setItem(prefixedKey, value ? JSON.stringify(value) : '')
    }, [prefixedKey, value])

    return [value, setValue]
}